import { Grid } from "@mui/material";
import { useContext, useState } from "react";
import { LanguageContext } from "../../../context/LanguageContext";
import { InnerWrapper, MainContainer, TitleAndActionBox } from "../../common";
import PrinterContainer from "../../container/Printer";
import { UBButton } from "../../../Libraries";

function Printer() {
  const [I18n] = useContext(LanguageContext);
  const [viewMode, setViewMode] = useState("steps");

  return (
    <MainContainer fluid className="quickSalePage">
      <Grid container>
        <Grid item md={12}>
          <TitleAndActionBox
            data={{
              title:
                viewMode == "steps" ? I18n.setup_your_printer : I18n.printers,
            }}
          />
          <InnerWrapper className="innerWrapper newInnerWrapper">
            <PrinterContainer viewMode={viewMode} setViewMode={setViewMode} />
          </InnerWrapper>
        </Grid>
      </Grid>
    </MainContainer>
  );
}

export default Printer;
